import React from 'react';

import { Modal, Title } from '@skillarea/lib-frontend';
import { GameReturnDto } from '@skillarea/lib-shared';
import { useTranslation } from 'react-i18next';

import { GamesSection } from '../GamesSection/GamesSection';

import styles from './GoPlayModal.module.scss';

export interface IGoPlayModalProps {
  isOpen: boolean;
  gamesData?: { items: Record<number, GameReturnDto> };
  games?: GameReturnDto[];
  isGamesLoading?: boolean;
  onClose: () => void;
  maxItems?: number;
}

export const GoPlayModal: React.FC<IGoPlayModalProps> = ({
  games,
  gamesData,
  isGamesLoading = false,
  isOpen,
  maxItems = 4,
  onClose,
}) => {
  const { t } = useTranslation('modals');
  const subtitle = t('goPlay.subtitle');

  return (
    <Modal
      classNameModal={styles.modal}
      description={subtitle}
      isOpen={isOpen}
      onBeforeClose={onClose}
      size="fullwidth"
      title={t('goPlay.title')}
    >
      <div className={styles.container} data-testid="go-play-modal">
        <div className={styles.header}>
          <Title as="h2" className={styles.title} color="contrast" size="xl">
            {t('goPlay.heading')}
          </Title>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>
        <GamesSection
          games={games}
          gamesData={gamesData}
          gridClassName={styles.gamesGrid}
          isLoading={isGamesLoading}
          maxItems={maxItems}
        />
      </div>
    </Modal>
  );
};
